import KYRVendorAppointmentComponent from './KYRVendorAppointmentComponent'
import {VENDOR_APPOINTMENT_TYPE_DOG_WALKING} from '../../KYRConstants'
import AbstractKYRScreen from '../AbstractKYRScreen'
import React from 'react'

export default class KYRDogWalkingComponent extends AbstractKYRScreen {
  render() {
    return <KYRVendorAppointmentComponent type={VENDOR_APPOINTMENT_TYPE_DOG_WALKING} navParams={this.props.navParams} />
  }
}
